var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1667H2C1.72667 15.1667 1.5 14.94 1.5 14.6667C1.5 14.3933 1.72667 14.1667 2 14.1667H14C14.2733 14.1667 14.5 14.3933 14.5 14.6667C14.5 14.94 14.2733 15.1667 14 15.1667Z",
    fill: "#009B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.68 2.82C11.3867 1.52667 10.12 1.49334 8.79334 2.82L7.98668 3.62667C7.92001 3.69334 7.89334 3.8 7.92001 3.89334C8.42668 5.66 9.84001 7.07334 11.6067 7.58C11.6333 7.58667 11.66 7.59334 11.6867 7.59334C11.76 7.59334 11.8267 7.56667 11.88 7.51334L12.68 6.70667C13.34 6.05334 13.66 5.42 13.66 4.78C13.6667 4.12 13.3467 3.48 12.68 2.82Z",
    fill: "#009B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4067 8.18667C10.2133 8.09334 10.0267 8.00001 9.84668 7.89334C9.70001 7.80667 9.56001 7.71334 9.42001 7.61334C9.30668 7.54001 9.17334 7.43334 9.04667 7.32667C9.03334 7.32001 8.98667 7.28001 8.93334 7.22667C8.71334 7.04001 8.46668 6.80001 8.24668 6.53334C8.22668 6.52001 8.19334 6.47334 8.14668 6.41334C8.08001 6.33334 7.96668 6.20001 7.86668 6.04667C7.78668 5.94667 7.69334 5.80001 7.60668 5.65334C7.50001 5.47334 7.40668 5.29334 7.31334 5.10667C7.19097 4.84445 6.8468 4.76655 6.64218 4.97117L2.89334 8.72001C2.80668 8.80667 2.72668 8.97334 2.70668 9.08667L2.34668 11.64C2.28001 12.0933 2.40668 12.52 2.68668 12.8067C2.92668 13.04 3.26001 13.1667 3.62001 13.1667C3.70001 13.1667 3.78001 13.16 3.86001 13.1467L6.42001 12.7867C6.54001 12.7667 6.70668 12.6867 6.78668 12.6L10.5417 8.84498C10.7422 8.64445 10.6669 8.29943 10.4067 8.18667Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.6492463bff838a01b3503fa49153ba32.svg";
export { ForwardRef as ReactComponent };